import { Box, Flex, Image } from "rebass/styled-components";
import styled from "styled-components";
import { Button, Link } from "../../Components/Button";
import { Body, Headline, Large3 } from "../../Components/Text";
import Lottie from "lottie-react";
import { RiClockwiseFill, RiTrophyLine } from "react-icons/ri";
import { HiOutlineVideoCamera } from "react-icons/hi";
import { BiErrorCircle, BiSolidChevronRight } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { SiEpicgames } from "react-icons/si";
import { SiRiotgames } from "react-icons/si";
import { SiSteam } from "react-icons/si";
import { SiBattledotnet } from "react-icons/si";
import { SiFaceit } from "react-icons/si";
import { TbClockX } from "react-icons/tb";

export const MatchHistoryPlatformIcon = styled.div<{ img: string }>`
  ${(props) => `background-image: url(${props.img});`}
  background-repeat: no-repeat;
  background-size: contain;

  height: 14px;
  position: absolute;
  right: 6%;
  top: 3%;

  width: 14px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    height: 14px;
    width: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.narrow}) {
    height: 10px;
    width: 10px;
  }
`;

export const MatchHistoryMapIcon = styled("div")<{ img: string }>`
  position: relative;
  background-size: contain;
  border-radius: 4px;
  height: 100px;
  width: 61px;

  @media (max-width: ${({ theme }) => theme.breaks.narrow}) {
    background-size: contain;
    height: 50px;
    width: 30px;
  }

  ${(props) => `background: url(${props.img}) no-repeat;`}
`;

export const MapName = styled("p")`
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    font-size: ${({ theme }) => theme.text.subheader.fontSize};
  }
`;

export const RefreshMatchesButton = styled(Button)`
  border-radius: 20px;
  font-size: ${({ theme }) => theme.text.subheader.fontSize};
  width: auto;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: 0;
  }
`;

export const RefreshMatchesButtonComplete = styled(RefreshMatchesButton)`
  padding-left: 22px;
  padding-right: 18px;
  :disabled,
  :hover:disabled {
    background-color: ${({ theme }) => theme.colors.envy};
    color: ${({ theme }) => theme.colors.ice};
    cursor: not-allowed;
  }
`;

export const GetMatchButton = styled(Button)`
  width: 100px;
  border-radius: 20px;
  margin-top: 30px;
`;

export const SubHeading = styled(Large3)`
  color: ${(props) => props.theme.colors.ice};
  font-weight: 600;

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    font-size: 24px;
  }
`;

export const AvatarRowCentered = styled(Flex)`
  flex-direction: row;
  justify-content: center;
  width: 70%;
  gap: 4px;
  flex-wrap: wrap;
`;

export const PlatformWrapper = styled(Flex)`
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  background: ${(props) => props.theme.colors.ice};
`;

export const StyledSteam = styled(Flex)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.championAlpha70};
  border: 2px solid ${({ theme }) => theme.colors.championAlpha90};
  border-radius: 10px;
  justify-content: center;
  align-items: center;
`;

export const FlashBannerWrapper = styled(Flex)`
  width: 100%;
`;

const FlashBanner = styled(Box)`
  align-items: center;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.navy};
  display: flex;
  font-size: ${({ theme }) => theme.text.footnote.fontSize};
  font-weight: 500;
  margin: 22px 20px 21px 0;
  padding: 6px 12px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: 0;
  }
`;

export const FlashBannerSuccess = styled(FlashBanner)`
  border: 1px solid ${({ theme }) => theme.colors.envy};
  background-color: ${({ theme }) => theme.colors.flashSuccess};
`;

export const FlashBannerWarning = styled(FlashBanner)`
  border: 1px solid ${({ theme }) => theme.colors.error};
  background-color: ${({ theme }) => theme.colors.flashWarning};
`;
export const StyledLink = styled(Box)`
  display: inline;
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.envy};
  text-underline-offset: 2px;
  &:hover {
    color: ${({ theme }) => theme.colors.envy};
    cursor: pointer;
  }
`;
export const MatchPreviewContent = styled(Flex)<{ backgroundImage: string }>`
  width: 100%;
  margin-top: 50px;
  min-height: 600px;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    background-image: none;
  }
`;

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colors.alert};
  font-size: ${({ theme }) => theme.text.headline.fontSize};
  margin-top: 20px;
`;

export const SuccessText = styled(ErrorText)`
  color: ${({ theme }) => theme.colors.envy};
`;

export const Column = styled(Flex)`
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;
export const TinyAvatar = styled(Image)`
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha40};
  border-radius: 24px;
  cursor: pointer;
  height: 24px;
  max-width: 100%;
  min-height: 24px;
  min-width: 24px;
  width: 24px;
`;
export const AvatarRow = styled(Flex)<{ lineColor?: string }>`
  flex-direction: row;
  gap: 7px;
  align-items: center;
  background: linear-gradient(
    90deg,
    ${({ theme, lineColor }) =>
        lineColor
          ? `color-mix(in srgb, ${lineColor} 50%, black)`
          : `color-mix(in srgb, ${theme.colors.navy} 50%, black)`}
      0%,
    ${({ theme, lineColor }) =>
        lineColor
          ? `color-mix(in srgb, ${lineColor} 50%, black)`
          : `color-mix(in srgb, ${theme.colors.navy} 50%, black)`}
      50%,
    ${({ theme, lineColor }) =>
        lineColor
          ? `color-mix(in srgb, ${lineColor} 50%, black)`
          : `color-mix(in srgb, ${theme.colors.navy} 50%, black)`}
      100%
  );
  background-size: 100% 2px;
  background-repeat: no-repeat;
  background-position: center;
  gap: 16px;
`;
export const TeamsRow = styled(Flex)`
  flex-direction: row;
  align-items: center;
  position: relative;
  flex-grow: 0;
  column-gap: 20px;
  row-gap: 40px;
  flex-wrap: wrap;
  width: 100%;
  > * {
    margin-right: auto;
    margin-left: auto;
  }
`;
const CollapsibleColumn = styled(Column)<{ collapsed: boolean }>`
  flex-basis: 40%;
  min-height: 100vh;
  height: auto;
  border-left: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};

  @keyframes matchesSlideIn {
    0% {
      left: 100%;
    }

    50% {
      left: 50%;
    }

    100% {
      left: 0%;
    }
  }

  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    flex-basis: 30%;
  }

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    ${(props) =>
      props.collapsed
        ? "display: none"
        : "animation: matchesSlideIn 0.3s 1; animation-timing-function: linear;"};
  }
`;

export const MatchHistoryContainer = styled(Flex)`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
`;
export const ViewableContainer = styled(Flex)`
  display: flex;
  max-height: 100vh;
  overflow: hidden;
  width: 100%;
  position: relative;
`;
export const StyledCollapsibleColumn = styled(CollapsibleColumn)`
  background: ${({ theme }) => theme.colors.darkerNed};
  min-width: 45%;

  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    position: absolute;
    z-index: 2;

    ${(props) =>
      props.collapsed
        ? "display: none"
        : "animation: matchesSlideIn 0.3s 1; animation-timing-function: linear;"};
  
`;
export const Table = styled.table`
  box-sizing: border-box;
  border-collapse: separate;
  border-spacing: 0px;
  table-layout: fixed;
  width: 100%;
`;

export const Divider = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  height: 0px;
  margin: 20px 0;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin: 20px 0;
  }
`;

const TableHead = styled.thead``;
export const TableBody = styled.tbody``;

export const TableRow = styled.tr<{
  isPreview?: boolean;
  noHover?: boolean;
  selected?: boolean;
}>`
  :hover {
    ${(props) =>
      props.selected || props.noHover
        ? ""
        : `background-color: ${props.theme.colors.nedLight}`};
    cursor: pointer;
  }

  ${(props) =>
    props.selected ? `background-color: ${props.theme.colors.darkerNed};` : ""};

  > td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  }

  > td:first-child {
    ${(props) =>
      props.isPreview
        ? `box-shadow: -4px 0 0 ${props.theme.colors.envy};`
        : ""};

    ${(props) =>
      props.selected
        ? `border-left: solid 1px ${props.theme.colors.chalkAlpha20};
           padding-left: 9px;`
        : ""};

    @media (max-width: ${({ theme }) => theme.breaks.medium}) {
      border-left: 0;

      ${(props) =>
        props.isPreview
          ? `border-left: solid 4px ${props.theme.colors.envy};
           padding-left: 6px;
           border-radius: none;`
          : ""};
    }
  }
`;

export const TableData = styled.td<{ selected?: boolean }>`
  padding: 10px;
  font-size: ${({ theme }) => theme.text.headline.fontSize};
  font-weight: ${({ theme }) => theme.text.large3.fontWeight};
  position: relative;
  > p {
    margin: 0;
  }

  & .tie {
    color: ${({ theme }) => theme.colors.error};
  }

  & .positive {
    color: ${({ theme }) => theme.colors.envy};
  }

  & .negative {
    color: ${({ theme }) => theme.colors.alert};
  }

  > .date {
    font-size: ${({ theme }) => theme.text.footnote.fontSize};
    color: ${({ theme }) => theme.colors.chalk};
  }
`;

export const ResponsiveLottie = styled(Lottie)`
  height: 16px;
  width: 16px;
  display: inline-block;
  position: relative;
  top: 2px;

  @media (max-width: ${({ theme }) => theme.breaks.narrow}) {
    height: 15px;
    width: 15px;
  }
`;

export const Separator = styled.span`
  display: inline-block;
  padding: 0 8px;

  @media (max-width: ${({ theme }) => theme.breaks.narrow}) {
    padding: 0 2px;
  }

  :before {
    content: "/";
  }
`;

export const Row = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const HeaderFlex = styled(Flex)`
  justify-content: space-between;
  gap: 12px;
  flex-direction: column;
  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    align-items: flex-start;
    margin-bottom: 10px;
  }
`;

export const SubText = styled(Headline)`
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  color: ${(props) => props.theme.colors.chalk};
`;

export const Trophy = styled(RiTrophyLine)`
  color: ${({ theme }) => theme.colors.envy};
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

export const Video = styled(HiOutlineVideoCamera)`
  color: ${(props) => props.theme.colors.envy};
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

export const MobileButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.navy};
  border-radius: 20px;
  width: 38px;
  height: 38px;
  padding: 0;
  display: none;
  margin-bottom: 12px;

  :hover {
    background-color: ${({ theme }) => theme.colors.midnight};
  }

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ProcessingButton = styled(Button)`
  border-radius: 999px;
  max-height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.envy};
  background-color: ${(props) => props.theme.colors.envyAlpha10};
  font-size: 16px;
  font-weight: 500;
  justify-content: space-between;
  align-items: center;
  padding-left: 18px;
  padding-right: 10px;
  &:hover {
    background-color: ${(props) => props.theme.colors.envyAlpha20};
  }
`;
export const MatchesContainer = styled(Box)`
  padding-left: 10px;
  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    padding: 0 20px;
  }

  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    padding: 0 10px;
  }
`;
export const MatchRowImageCell = styled(Flex)`
  gap: 30px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    gap: 10px;
  }
`;
export const MatchRowImage = styled(Image)`
  height: 100%;
  width: 100%;
`;
export const ErrorImage = styled(Flex)`
  height: 100%;
  width: 200px;
  aspect-ratio: 55/100;
  border-radius: 4px;
  background: var(--Gray-850, #141e26);
  align-items: center;
  justify-content: center;
`;
export const ErrorIcon = styled(BiErrorCircle)`
  color: ${({ theme }) => theme.colors.alert};
  width: 18px;
`;
export const OutdatedIcon = styled(TbClockX)`
  color: ${({ theme }) => theme.colors.error};
  width: 18px;
`;
export const MatchRowImageContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  max-width: 60px;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    max-width: 40px;
  }
`;
export const LeagueMatchChampionImage = styled(Image)`
  height: auto;
  max-height: 100px;
  width: auto;
  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    max-height: 50px;
  }
`;
export const StyledScrollableContainer = styled(Flex)`
  -ms-overflow-style: none;
  display: block;
  height: auto;
  overflow-y: scroll;
  position: relative;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const StyledTable = styled(Table)`
  font-size: ${({ theme }) => theme.fontSizes[2]};
  @media (max-width: 1600px) {
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }
`;

export const StyledChevron = styled(BiSolidChevronRight)`
  color: ${({ theme }) => theme.colors.chalk};
`;

export const WarningText = styled(Body)`
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: 500;
`;

export const BoldText = styled(Body)`
  font-weight: 600;
  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    display: none;
  }
`;

export const Date = styled(Body)`
  font-size: ${({ theme }) => theme.fontSizes[0]};
  color: ${({ theme }) => theme.colors.chalk};
`;

export const VictoryText = styled(Body)`
  color: ${({ theme }) => theme.colors.envy};
`;

export const DefeatText = styled(Body)`
  color: ${({ theme }) => theme.colors.alert};
`;
export const NotVictoryText = styled(Body)`
  color: ${({ theme }) => theme.colors.alert};
`;
export const TieText = styled(Body)`
  color: ${({ theme }) => theme.colors.error};
`;
export const TransitTimeWrapper = styled(Box)`
  > div > div {
    margin-bottom: 20px;

    :last-child {
      margin-bottom: 0px;
    }
  }
  border-radius: 16px;
  mix-blend-mode: normal;
  width: 100%;
  border-color: #233438;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 0 30px #233438;
  background-color: #10161a;
  padding: 20px;
`;

export const CloseButton = styled(MdClose)`
  fill: ${({ theme }) => theme.colors.chalk};
  width: 20px;
  height: 20px;
  #parent:not(:has(#child:hover)):hover { ... }
  &:hover {
    cursor: pointer;
    background: ${(props) => props.theme.colors.alert};
    fill: ${({ theme }) => theme.colors.ice};
    border-radius: 99px;
    pointer-events: all;
  }
`;

export const PlayerPill = styled(Flex)`
  border: 1px solid ${(props) => props.theme.colors.chalkAlpha20};
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 99px;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  gap: 4px;
  pointer-events: auto;
  align-items: center;
`;
export const DropdownContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 50%;
`;

export const Dropdown = styled(Flex)`
  flex-direction: column;
  color: ${(props) => props.theme.colors.ice};
  white-space: nowrap;
  background-color: ${(props) => props.theme.colors.navy};
  border-radius: 8px;
  padding: 10px;
`;

export const DropdownTopSection = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;

export const StyledButtonContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  text-align: left;
  min-width: 75px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  height: 35px;
  border-radius: 8px;
  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.midnightAlpha50};
    color: ${(props) => props.theme.colors.envy};
  }
`;

export const StyledFaceitIcon = styled(SiFaceit)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
  margin-bottom: -2px;
`;

export const StyledSteamIcon = styled(SiSteam)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const StyledRiotIcon = styled(SiRiotgames)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const StyledEpicIcon = styled(SiEpicgames)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const StyledBattleNetIcon = styled(SiBattledotnet)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
  color: #148eff;
`;
